import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { mapGraphQLErrors } from 'providers/tanstack-query/utils'
import { Schema } from '../../schema'
import { toDTO } from './api/mapper'
import { UPDATE_WORKSPACE_PRODUCT } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateWorkspaceProduct } from './types'

export const useUpdateWorkspaceProduct = (): UseUpdateWorkspaceProduct => {
  const { t } = useTranslation('features/performance')
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})
  const [loading, setLoading] = useState<boolean>(false)

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_WORKSPACE_PRODUCT,
    onCompleted: async (data: Data) => {
      const {
        updateWorkspaceProduct: { errors },
      } = data

      setLoading(false)

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), { variant: 'error' })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getWorkspaceForPerformance'],
  })

  const updateWorkspaceProduct = (data: Schema): void => {
    setLoading(true)

    mutateAsync({
      input: toDTO(data),
    })
  }

  return { errors, loading, updateWorkspaceProduct }
}
